<template>
  <div class="content">
    <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item prop="fieldType" label-width="151px" label="类型">
        <el-radio v-model="ruleForm.fieldType" label="1" >ICCID</el-radio>
        <el-radio v-model="ruleForm.fieldType" label="2" >MSISDN</el-radio>
      </el-form-item>
      <el-form-item :label="ruleForm.fieldType == '1' ? 'ICCID' : 'MSISDN'"  prop="iccids" label-width="151px">
        <el-input
          v-model="ruleForm.iccids"
          type="textarea"
          placeholder="以回车键分割ICCID"
          rows="6"
          style="width:420px"
          @input="changeRevoceryIccids"
        ></el-input>
        <div class="card-num" v-if="revoceryIccidsCount>0"><span>总数：</span><span>{{revoceryIccidsCount}}</span></div>
      </el-form-item>
      <el-form-item :label="ruleForm.fieldType == '1' ? 'ICCID范围' : 'MSISDN范围'"  prop="startIccid" label-width="151px">
        <el-input
          v-model="ruleForm.startIccid"
          style="width: 200px;margin-right: 10px;"
          placeholder="包含开始值"
          @input="changeRevoceryIccidRangeCount"
        ></el-input>
        <span>-</span>
        <el-input
          v-model="ruleForm.endIccid"
          style="width: 200px;margin-left: 10px;"
          placeholder="包含终止值"
          @input="changeRevoceryIccidRangeCount" 
        ></el-input>
        <div class="card-num" v-if="revoceryRangeCount>0"><span>总数：</span><span>{{revoceryRangeCount}}</span></div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="poolRecyling" v-hasPermi="['pondManage:recycle']">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { poolRecyclingPoolCard, selectCount } from "@/api/api.js";
export default {
  name:"poolRecovery",
  data() {
    return {
      ruleForm: {
        fieldType:'1',
        iccids:'',
        startIccid:'',
        endIccid:'',
      },
      revoceryIccidsCount:0,
      revoceryRangeCount:0,
    };
  },
  methods: {
    poolRecyling() {
      let data = {
        ...this.ruleForm,
        iccids:this.ruleForm.iccids ? this.ruleForm.iccids.split("\n") : []
      };
      poolRecyclingPoolCard(data).then(res => {
          this.$notify.info({
            title: "提示",
            message: "已提交卡回收，请在任务中心查看进度",
            duration: 1000,
            offset:30
          });
          setTimeout(()=>{
            this.$store.dispatch('tagsView/delView', this.$route)
            this.$router.push(`/taskCenter/missionList`);
          },1000)
      });
    },
    changeRevoceryIccids(){
      let arrIccids = this.ruleForm.iccids ? this.ruleForm.iccids.split("\n") : []
      this.revoceryIccidsCount = arrIccids.filter(item=>!!item).length
    },
    changeRevoceryIccidRangeCount(){
      this.revoceryRangeCount = 0
      let fieldType = this.ruleForm.fieldType
      if(!!this.ruleForm.startIccid && !!this.ruleForm.endIccid){
            if(this.ruleForm.fieldType === '1'  && this.ruleForm.startIccid.length>18 && this.ruleForm.endIccid.length>18){
              let startIccid = this.ruleForm.startIccid
              let endIccid =  this.ruleForm.endIccid
              selectCount({fieldType,startIccid,endIccid}).then(res=>{
                this.revoceryRangeCount = res.data.data
              })
            }
            if(this.ruleForm.fieldType === '2'  && this.ruleForm.startIccid.length>12 && this.ruleForm.endIccid.length>12){
              let startIccid = this.ruleForm.startIccid
              let endIccid =  this.ruleForm.endIccid
              selectCount({fieldType,startIccid,endIccid}).then(res=>{
                this.revoceryRangeCount = res.data.data
              })
            }
      }

    }
  },
};
</script>
<style scoped lang="less">
  .card-num{
    height: 20px;
    line-height: 20px;
    span:nth-of-type(2){
      color:red
    }
  }
</style>